// extracted by mini-css-extract-plugin
module.exports = {"access":"Users_access__5O3MF"};